import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import isGroupSelected from './isGroupSelected';

export default function isMessageActionFromGroup(): boolean {
    return isGlobalFeatureEnabled('grp-loadFolders') && isGroupSelected();
}
